import script from "./kehuList.vue?vue&type=script&setup=true&lang=js"
export * from "./kehuList.vue?vue&type=script&setup=true&lang=js"

import "./kehuList.vue?vue&type=style&index=0&id=573c546c&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573c546c"]])

export default __exports__